<template lang="pug">
.generic-wrapper
  .container
    BackButton(name="SettingsOverview")
    h1.title Geschäftslogik
    .sub-headline Hier können Sie die Einstellungen Ihrer Geschäftslogik verwalten.

    //- b-message.margin-top(title="Sie sollten wissen, was Sie tun" type="is-danger" has-icon :closable="false")
      |Diese Einstellungen werden in der Regel einmalig oder in Absprache mit dem Systemadminstrator durchgeführt.
      br
      |Eine Veränderung der Daten führt zu einer sofortigen Veränderung in den Geschäftsabläufen.

    .settings-wrapper.margin-top
      b-tabs(vertical)
        b-tab-item(icon="information-outline" label="Agentur Informationen")
          .form.w400
            .card
              .top
                .left
                  .card-headline Allgemein
                  .card-description Die folgenden Felder haben Einfluss auf die Fußleiste im PDF.
                .right
              .main.padding
                  b-field(label-position="on-border" label="Name Agentur")
                    b-input(v-model="settings.agencyCompanyName")
                  .info-p Unter diesem Link können Sie ein .JPEG Bild in eine Base64 Zeichenkette umwandeln: https://www.base64-image.de/
                    br
                    |Vorteil: Ein Bild als Base64 Zeichenkette kann in einer E-Mail nicht blockiert werden.
                  b-field(label-position="on-border" label="Bildlogo für E-Mail und PDF (Base64 String)")
                    b-input(type="textarea" maxlength="65000" v-model="settings.agencyLogoBase64")
                  b-field(label-position="on-border" label="Name Geschäftsführer/in")
                    b-input(v-model="settings.agencyCompanyOwnerName")
                  b-field(label-position="on-border" label="Portal-Domain (ohne https://)")
                    b-input(v-model="settings.agencyPortalUrl")
                  b-field(label-position="on-border" label="Mögliche Buchungsquellen")
                    b-input(v-model="settings.referralList")
                  b-field(label-position="on-border" label="Öffnungszeiten")
                    b-input(v-model="settings.openingInformation")
                  .button-wrapper.right
                    b-button(type="is-primary" @click="saveSettings()") Speichern
            .card.margin-top
              .top
                .left
                  .card-headline Adresse
                  .card-description Die folgenden Felder haben Einfluss auf die Fußleiste im PDF.
                .right
              .main.padding
                  b-field(label-position="on-border" label="Straße")
                    b-input(v-model="settings.agencyStreet")
                  b-field(label-position="on-border" label="PLZ")
                    b-input(v-model="settings.agencyZip")
                  b-field(label-position="on-border" label="Stadt")
                    b-input(v-model="settings.agencyCity")
                  b-field(label-position="on-border" label="Telefon")
                    b-input(v-model="settings.agencyPhone")
                  b-field(label-position="on-border" label="Fax")
                    b-input(v-model="settings.agencyFax")
                  b-field(label-position="on-border" label="E-Mail")
                    b-input(v-model="settings.agencyEmail")
                  .button-wrapper.right
                    b-button(type="is-primary" @click="saveSettings()") Speichern
            .card.margin-top
              .top
                .left
                  .card-headline Bankdaten
                  .card-description Die folgenden Felder haben Einfluss auf die Fußleiste im PDF.
                .right
              .main.padding
                  b-field(label-position="on-border" label="Bankname")
                    b-input(v-model="settings.agencyBankName")
                  b-field(label-position="on-border" label="IBAN")
                    b-input(v-model="settings.agencyIban")
                  b-field(label-position="on-border" label="BIC")
                    b-input(v-model="settings.agencyBic")
                  b-field(label-position="on-border" label="Handelsregisternummer")
                    b-input(v-model="settings.agencyRegistrar")
                  b-field(label-position="on-border" label="St.-Nr.")
                    b-input(v-model="settings.agencyTaxId")
                  b-field(label-position="on-border" label="Ust.-IdNr.")
                    b-input(v-model="settings.agencyVatId")
                  .button-wrapper.right
                    b-button(type="is-primary" @click="saveSettings()") Speichern
        b-tab-item(icon="palette" label="Farben Einstellungen")
          .form.w400
            .card
              .top
                .left
                  .card-headline Objekttypen Farben
                  .card-description Die folgenden Felder haben Einfluss auf die Objekttypfarben im Buchungskalender (linke Leiste).
                .right
              .main.padding
                  b-field(v-for="type in rentObjectTypes" label-position="on-border" :label="type.name")
                    v-swatches(v-model="type.colorCode" swatches="text-advanced" show-fallback)
                  .button-wrapper.right
                    b-button(type="is-primary" @click="updateRentObjectTypeColors()") Speichern
            .card.margin-top
              .top
                .left
                  .card-headline Buchungsstatus Farben
                  .card-description Die folgenden Felder haben Einfluss auf die Buchungsfarben im Buchungskalender.
                .right
              .main.padding
                  b-field(v-for="status in bookingStatus" label-position="on-border" :label="status.name")
                    v-swatches(v-model="status.colorCode" swatches="text-advanced" show-fallback)
                    .spacer.md
                    b-switch(type="is-success" size="is-small" v-model="status.isVisible") Sichtbar
                    .spacer.md
                    b-switch(type="is-success" size="is-small" v-model="status.isActive") Aktiviert
                  .button-wrapper.right
                    b-button(type="is-primary" @click="updateBookingStatusColors()") Speichern
            .card.margin-top(v-if="settings")
              .top
                .left
                  .card-headline Buchungskalender Farben
                  .card-description Die folgenden Felder haben Einfluss auf die Darstellungen im Buchungskalender.
                .right
              .main.padding
                  b-field(label-position="on-border" label="Samstag Farbe")
                    v-swatches(v-model="settings.colorCodeSaturday" swatches="text-advanced" show-fallback)
                  b-field(label-position="on-border" label="Sonntag Farbe")
                    v-swatches(v-model="settings.colorCodeSunday" swatches="text-advanced" show-fallback)
                  b-field(label-position="on-border" label="Tageshighlight Farbe")
                    v-swatches(v-model="settings.colorCodeToday" swatches="text-advanced" show-fallback)
                  b-field(label-position="on-border" label="Zeitraumhighlight Farbe")
                    v-swatches(v-model="settings.colorCodeDateRange" swatches="text-advanced" show-fallback)
                  .button-wrapper.right
                    b-button(type="is-primary" @click="saveSettings()") Speichern

        b-tab-item(icon="cash-100" label="Finanzielle Einstellungen" v-if="settings")
          .form.w400
            .card
              .top
                .left
                  .card-headline Finanzielle Einstellungen
                  .card-description Die folgenden Felder haben Einfluss auf jegliche Kalkulation.
                .right
              .main.padding
                b-field(label="Mehrwertsteuer in %")
                  b-numberinput(type="is-light" min="0" max="30" v-model="settings.vat")
                .button-wrapper.right
                  b-button(type="is-primary" @click="saveSettings()") Speichern
            .card.margin-top
              .top
                .left
                  .card-headline Mietvertrag Einstellungen
                  .card-description Die folgenden Felder haben Einfluss auf den Mietvertrag.
                .right
              .main.padding
                b-field(label="Vertrag zurück Zeitraum")
                  b-numberinput(type="is-light" min="0" max="100" v-model="settings.contractBackDays")
                b-field(label="Anzahlung in Prozent")
                  b-numberinput(type="is-light" min="0" max="100" v-model="settings.downPaymentPercentage")
                b-field(label="Anzahlung aktiv bei x Tagen vor Anreise")
                  b-numberinput(type="is-light" min="1" v-model="settings.downPaymentDaysBeforeArrival")
                b-field(label="Anzahlung muss nach x Tagen gezahlt werden")
                  b-numberinput(type="is-light" min="0" :max="settings.downPaymentDaysBeforeArrival - settings.finalPaymentDaysBeforeArrival" v-model="settings.downPaymentDaysAfterBooking")
                b-message(type="is-warning" size="is-small" :closable="false" v-if="settings.downPaymentDaysBeforeArrival - settings.finalPaymentDaysBeforeArrival <= settings.downPaymentDaysAfterBooking")
                  |Sie können nur maximal auf {{settings.downPaymentDaysBeforeArrival - settings.finalPaymentDaysBeforeArrival}} setzen, da ein höherer Wert mit der Restzahlung kollidieren würde. Erhöhen Sie die Tage der Anzahlungs-Pflicht, um einen höheren Wert einzustellen.
                b-field(v-if="settings.downPaymentPercentage < 100" label="Restzahlung Zahlungszeitraum - Tage vor der Anreise")
                  b-numberinput(type="is-light" min="0" v-model="settings.finalPaymentDaysBeforeArrival")
                p(v-else) Da die Anzahlung 100% beträgt wird diese damit zur einer 'Gesamtzahlung'.
                .breaker
                b-field(label="Sofort Zahlungszeitraum - Bei Unterschreitung der Mindesttage")
                  b-numberinput(type="is-light" min="0" v-model="settings.immediatePaymentDaysAfterBooking")
                b-message(v-if="settings.finalPaymentDaysAfterBooking <= 0" type="is-warning" size="is-small" :closable="false")
                  |In diesem Fall wird auf dem Mietvertrag mit dem Wortlaut <b>'sofort'</b> gearbeitet.
                .button-wrapper.right
                  b-button(type="is-primary" @click="saveSettings()") Speichern
            .card.margin-top
              .top
                .left
                  .card-headline Stornoabrechnung Einstellungen
                  .card-description Die folgenden Felder haben Einfluss auf die Stornorechnung.
                .right
              .main.padding
                b-field(:label="`Stornogebühr ${settings.cancelInvoiceFee/100}€`")
                  b-input(:value="settings.cancelInvoiceFee/100" @input="$set(settings, 'cancelInvoiceFee', sanitizeNumber($event) * 100)")
                b-field(label="Stornoabrechnung Zahlungszeitraum")
                  b-numberinput(type="is-light" min="0" v-model="settings.cancelInvoicePaymentDays")
                b-field(label="Guthaben Zahlungszeitraum")
                  b-numberinput(type="is-light" min="0" v-model="settings.fundsPaymentDays")
                .label Stornostaffelung
                p Um eine gültige Staffelung zu generieren, müssen die Tage von oben nach unten kleiner werden.
                .staffelung(v-for="graduation, idx in settings.cancelInvoiceGraduation")
                  b-field(label-position="on-border" label="% vom Objektpreis")
                    b-input(v-model="graduation.percentageFromTotalPrice")
                  .spacer.sm
                  b-field(label-position="on-border" label="Tage vor Anreise")
                    b-input(v-model="graduation.daysBeforeArrival")
                  .spacer.sm
                  .button-wrapper
                    b-tooltip(label='Dauerhaft löschen' type='is-danger' position='is-bottom' :delay="1250")
                      b-button(icon-right="close", type="is-danger" @click="deleteCancelInvoiceGraduation(idx)")
                b-message(v-if="!cancelInvoiceGraduationIsValid" type="is-danger" size="is-small" :closable="false")
                  |Bitte stellen Sie sicher, dass die Tage der Staffelungen von oben nach unten kleiner werden.
                b-message(v-if="!cancelInvoiceGraduationIsValid" type="is-danger" size="is-small" :closable="false")
                  |Eine der Staffelungen enthält ungültige Werte.
                b-message(v-if="settings.cancelInvoiceGraduation.length === 0" type="is-warning" size="is-small" :closable="false")
                  |Wenn keine Staffelung generiert wird, wird die Stornoabrechnung mit 0% vom Gesamtmietbetrag angesetzt.
                b-button(type="is-light" icon-left="plus" @click="addCancelInvoiceGraduation()") Neue Staffelung
                .button-wrapper.right
                  b-button(type="is-primary" @click="saveSettings()") Speichern
        b-tab-item(icon="car-brake-alert" label="Rechtliche Einstellungen" v-if="settings")
          .form.w400
            .card
              .top
                .left
                  .card-headline Rechtlich relevante Einstellungen
                  .card-description Die folgenden Felder haben potentiell rechtliche relevanz für Ihr Unternehmen.
                .right
              .main.padding
                b-field(label="Datenschutz-Grundverordnung")
                  b-switch(type="is-success" v-model="settings.gdprIsActive") DSGVO aktivieren
                b-field(grouped)
                  b-field
                    b-numberinput(type="is-light" min="1" max="1000" v-model="settings.gdprDeleteBookingAfterDays")
                  b-field
                    div Tage nachdem die<br> Anonymisierung erfolgt
                b-message(type="is-warning" size="is-small" :closable="false")
                  |Es werden alle Gastdaten anonymisiert - mit Außnahme der Stadt und PLZ. Diese bleiben bestehen, um statische Erhebungen zu den Buchungen zu machen.
                
                .label Zahlungserinnerung & Mahnungen
                p Folgend können Sie die Mahnfristen für Zahlungserinnerungen und Mahnungen festlegen.
                b-field(grouped)
                  b-field(label="Erinnerungsfrist")
                    b-numberinput(type="is-light" min="1" max="1000" v-model="settings.paymentReminder1DueDays")
                  b-field(label="Mahnungsfrist")
                    b-numberinput(type="is-light" min="1" max="1000" v-model="settings.paymentReminder2DueDays")
                b-field
                  b-checkbox(type="is-success" v-model="settings.canOverridePaymentReminderDueDays") Überschreiben möglich

                .label Löschung von Buchungen
                p Wenn dieser Wert aktiviert ist, kann jede Buchung gelöscht werden. Es wird nicht empfohlen diesen Hebel zu aktivieren. Es kann zu Problemen mit der Eigentümerabrechnung kommen.
                b-field
                  b-checkbox(type="is-success" v-model="settings.canDeleteAllBookings") Alle Buchungen können gelöscht werden

                .button-wrapper.right
                  b-button(type="is-primary" @click="saveSettings()") Speichern
        b-tab-item(icon="cog-outline" label="Sonstige Einstellungen" v-if="settings")
          .form.w400
            .card
              .top
                .left
                  .card-headline Sonstige Einstellungen
                  .card-description Die folgenden Felder können Auswirkungen auf Ihre Geschäftslogik haben.
                .right
              .main.padding
                b-field(label="Anreise E-Mail Alarm")
                  b-numberinput(type="is-light" min="1" max="1000" v-model="settings.sendInfoEmailBeforeArrivalDays")
                b-message(type="is-info" size="is-small" :closable="false")
                    | Sobald eine Buchung {{settings.sendInfoEmailBeforeArrivalDays}} Tage vor der Anreise ist, wird diese im Dashboard erscheinen, damit eine Anreise-E-Mail verschickt werden kann.
                b-field(label="Standard Anreise E-Mail Vorlage" label-position="on-border")
                    b-select(v-model="settings.fallbackArrivalEmailTemplateId" disabled)
                      option(v-for="emailTemplate in arrivalEmailTemplates" :value="emailTemplate.id") {{emailTemplate.subject}}
                
                .button-wrapper.right
                  b-button(type="is-primary" @click="saveSettings()") Speichern
</template>

<script>
import VSwatches from 'vue-swatches';
import 'vue-swatches/dist/vue-swatches.css';

export default {
  components: {
    VSwatches
  },
  data() {
    return {
      bookingStatus: [],
      rentObjectTypes: [],
      settings: null
    };
  },
  computed: {
    cancelInvoiceGraduationIsValid() {
      let days;
      for (let i = 0; i < this.settings.cancelInvoiceGraduation.length; i += 1) {
        if (this.settings.cancelInvoiceGraduation[i].daysBeforeArrival === '' || this.settings.cancelInvoiceGraduation[i].daysBeforeArrival === null || this.settings.cancelInvoiceGraduation[i].percentageFromTotalPrice === '' || this.settings.cancelInvoiceGraduation[i].percentageFromTotalPrice === null) return false;
        if (i === 0) {
          days = this.settings.cancelInvoiceGraduation[i].daysBeforeArrival
          continue;
        }

        if (this.settings.cancelInvoiceGraduation[i].daysBeforeArrival >= days) return false;
      }
      return true;
    },
    arrivalEmailTemplates() {
      return this.$store.state.emailTemplates.all.filter(t => t.uuid.includes('ARRIVAL'));
    }
  },
  async mounted() {
    this.settings = await this.$store.dispatch("settings/find");
    // this.settings.cancelInvoiceFee = this.settings.cancelInvoiceFee / 100;
    this.bookingStatus = await this.$store.dispatch("bookingStatus/findAll");
    this.rentObjectTypes = await this.$store.dispatch("rentObjectTypes/findAll");
    this.$store.dispatch("emailTemplates/findAll");
  },
  methods: {
    addCancelInvoiceGraduation() {
      this.settings.cancelInvoiceGraduation.push({
        percentageFromTotalPrice: null,
        daysBeforeArrival: null
      })
    },
    deleteCancelInvoiceGraduation(idx) {
      this.settings.cancelInvoiceGraduation.splice(idx, 1);
    },
    sanitizeNumber(nbr) {
      // So that nobody can type in weired data
      if (!parseInt(nbr)) return 0
      if (nbr.length <= 0) return 0
      return parseInt(nbr)
    },
    async saveSettings() {
      const loadingComponent = this.$buefy.loading.open();
      await this.$store.dispatch("settings/update", this.settings);
      this.settings = await this.$store.dispatch("settings/find");
      loadingComponent.close();
    },
    async updateRentObjectTypeColors() {
      await this.$store.dispatch("rentObjectTypes/updateColors", this.rentObjectTypes);
      this.rentObjectTypes = await this.$store.dispatch("rentObjectTypes/findAll");
    },
    async updateBookingStatusColors() {
      await this.$store.dispatch("bookingStatus/updateColorsAndVisibility", this.bookingStatus);
      this.bookingStatus = await this.$store.dispatch("bookingStatus/findAll");
    }
  }
};
</script>

<style lang="scss" scoped>
.staffelung {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.info-p {
  font-size: 0.8rem;
}
</style>